'use client';

import React, { useEffect, useState } from 'react';

import ClientOnly from '@/components/client-only';
import { useAuth } from '@/provider/UserProvider';
import { getPlan } from '@/services/pricing';
import SkeletonSubscription from './SkeletonSubscription';
import Subscription from './Subscription';

export enum TabKey {
  Card = 'card',
  AIRI = 'airi',
}
interface PlanOnlyOnce {
  starter: boolean;
}
export interface SubscriptionResponse {
  subscription: {
    plan: string;
    enddate: number;
    status: string;
  };
  planOnlyOnce: PlanOnlyOnce;
}

const Pricing = ({}) => {
  const { auth, setAuth, isLoginClient } = useAuth();
  const [data, setData] = useState<SubscriptionResponse | null>(null);

  const handleGetPlan = async () => {
    const res = await getPlan();
    setData(res);
  };

  useEffect(() => {
    if (data && data.subscription !== null && !auth.user.isPlus) {
      setAuth({ ...auth, user: { ...auth.user, isPlus: true } });
    } else if (data && data.subscription === null && auth.user.isPlus) {
      setAuth({ ...auth, user: { ...auth.user, isPlus: false } });
    }
  }, [data]);

  useEffect(() => {
    if (isLoginClient) {
      handleGetPlan();
    } else {
      setData(null);
    }
  }, [isLoginClient]);

  return (
    <ClientOnly skeleton={<SkeletonSubscription />}>
      <div className="pt-[3%]">
        <Subscription data={data} />
      </div>
    </ClientOnly>
  );
};

export default Pricing;
